export const MOEDAS_TOKEN = 'moedasEnv'
